import { api } from "./axiosInstance";
import type { Visit } from "../types/domain.types";

export interface RegisterVisitInput {
  markerId: string;
  comment?: string;
}

export interface VisitResponse {
  id: string;
  visitedAt: string;
  comment: string | null;
  user: { id: string; email: string };
}

export async function registerVisitRequest(
  input: RegisterVisitInput,
): Promise<VisitResponse> {
  const { data } = await api.post<VisitResponse>(
    `/markers/${input.markerId}/visits`,
    { comment: input.comment },
  );
  return data;
}

export interface VisitByQrInput {
  planId: string;
  qrCode: string;
  comment?: string;
}

export interface VisitByQrResponse {
  visitedCount: number;
  markerIds: string[];
  visitedAt: string;
}

export async function visitByQrRequest(
  input: VisitByQrInput,
): Promise<VisitByQrResponse> {
  const { data } = await api.post<VisitByQrResponse>(
    "/markers/visit-by-qr",
    input,
  );
  return data;
}

export async function listVisitsRequest(markerId: string): Promise<Visit[]> {
  const { data } = await api.get<Visit[]>(`/markers/${markerId}/visits`);
  return data;
}
